<div class="withdrawals">
  @if (authState.user(); as loggedUser) {
    @if (loggedUser.needPlayGames > 0) {
      <div class="withdrawals__warning warning" (click)="openNeedPlayGamesDialog()">
        <i class="icon icon_info-circle-bold icon_informer"></i>
        <p class="warning__text" i18n="@@profile.withdrawals.need_play_games_alert">
          Игр нужно сыграть, чтобы открыть выводы: {{ loggedUser.needPlayGames | number }}
        </p>
      </div>
    }
  }

  @if (!isLg()) {
    <div class="w-full">
      <div class="withdrawals__table table w-full overflow-x-hidden px-[3.2rem] pb-[2.8rem] lg:px-0 lg:pb-[1.6rem]">
        @if (!isLoading()) {
          @if (withdrawalsState.withdrawals().length > 0) {
            <div class="table__head mb-[1rem] px-[1.6rem] text-[1.2rem] font-350 leading-[1.6rem] text-light-200">
              <div>ID</div>
              <div i18n="@@profile.withdrawals.way">Способ</div>
              <div i18n="@@profile.withdrawals.items">Предметы</div>
              <div></div>
              <div i18n="@@profile.withdrawals.date">Дата</div>
              <div class="text-right" i18n="@@profile.withdrawals.status">Статус</div>
            </div>

            <div class="table__wrapper flex flex-col space-y-[0.2rem] lg:px-[1.6rem]">
              @for (withdrawal of withdrawalsState.withdrawals(); track withdrawal.id) {
                <withdrawals-table-item
                  class="table__row h-[6rem] shrink-0 rounded-[1.2rem] bg-[#202956] px-[1rem] lg:h-[9.8rem]"
                  [withdrawal]="withdrawal"
                />
              }
            </div>
          } @else {
            <div class="withdrawals__empty-block empty-block py-[3rem]">
              <div class="empty-block__icon icon icon_grid-th"></div>
              <div class="empty-block__title" i18n="@@profile.withdrawals.empty">Выводов еще не было</div>
            </div>
          }
        } @else {
          <div class="table__wrapper lg:flex lg:w-full lg:flex-col lg:space-y-[0.2rem] lg:px-[1.6rem] lg:pb-[1.6rem]">
            @for (row of preloadRows; track $index) {
              <preload-rect
                className="w-full h-[6rem] !rounded-[1.2rem] lg:h-[9.8rem] !shrink-0 preload"
                [background]="'#202956'"
              />
            }
          </div>
        }
      </div>
    </div>
  } @else {
    @if (!isLoading()) {
      @if (withdrawalsState.withdrawals().length > 0) {
        <div
          class="mob-table-wrapper flex max-h-[69.8rem] w-full flex-col space-y-[0.2rem] overflow-auto px-[1.6rem] pb-[1.6rem]"
        >
          @for (withdrawal of withdrawalsState.withdrawals(); track withdrawal.id) {
            <withdrawals-table-item
              class="flex h-[9.8rem] w-full shrink-0 flex-col justify-between space-y-[0.8rem] rounded-[1.2rem] bg-[#202956] p-[1rem] lg:h-[9.8rem]"
              [withdrawal]="withdrawal"
            />
          }
        </div>
      } @else {
        <div class="withdrawals__empty-block empty-block mx-[1.6rem] mb-[1.6rem] py-[3rem]">
          <div class="empty-block__icon icon icon_grid-th"></div>
          <div class="empty-block__title" i18n="@@profile.withdrawals.empty">Выводов еще не было</div>
        </div>
      }
    } @else {
      <div class="table__wrapper lg:flex lg:w-full lg:flex-col lg:space-y-[0.2rem] lg:px-[1.6rem] lg:pb-[1.6rem]">
        @for (row of preloadRows; track $index) {
          <preload-rect
            className="w-full h-[6rem] !rounded-[1.2rem] lg:h-[9.8rem] !shrink-0 preload"
            [background]="'#202956'"
          />
        }
      </div>
    }
  }
</div>
